import { Box, Stack, Typography } from "@mui/material";
const Vision = () => {
  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90%",
        margin: "auto",
      }}
    >
      <Stack
        direction="column"
        alignItems="flex-start"
        justifyContent="center"
        sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
      >
        <Stack
          sx={{
            backgroundColor: "primary.light",
            p: { xs: 1, md: 3 },
          }}
          spacing={2}
          direction="column"
          alignItems="flex-start"
          justifyContent="center"
        >
          <Typography
            variant="h5"
            sx={{ textDecoration: "underline", fontSize: 30 }}
          >
            Vision
          </Typography>
          <Typography
            variant="body2"
            fontSize={"1rem"}
            sx={{ px: { xs: 0, md: 10 } }}
          >
            To create a best possible environment to prepare physiotherapist who
            shall lead to serve and heal in a variety of health care and social
            setting to provide the best quality of life to an individual.
          </Typography>

          <Typography
            variant="h5"
            sx={{ textDecoration: "underline", fontSize: 30 }}
          >
            Mission
          </Typography>
          <Typography
            variant="body2"
            fontSize={"1rem"}
            sx={{ px: { xs: 0, md: 10 } }}
          >
            To graduate knowledge, service oriented, self assured, adaptable,
            reflective practitioners who, by virtue of critical and integrative
            thinking along with clinical reasoning, ethical values and render
            independent judgment concerning patients/ person needs those are
            supported by evidence, promote the health of the patient or person,
            and enhance the professional contextual and collaborative foundation
            for the physiotherapy practice.
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default Vision;
